import { useCallback, useEffect, useRef, useState } from 'react'

interface TimerProps {
  initialTime: number
  onFinish: () => void
}

export const useTimer = ({ initialTime, onFinish }: TimerProps): [number, () => void, () => void] => {
  const intervalIdRef = useRef<number | null>(null)
  const [value, setValue] = useState<number>(initialTime)

  const reset = useCallback(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current)
      intervalIdRef.current = null
      setValue(0)
    }
  }, [])

  const start = useCallback(() => {
    reset()
    setValue(initialTime)
    const intervalFunc = () => {
      setValue((v) => v - 1)
    }

    intervalIdRef.current = setInterval(intervalFunc, 1000) as unknown as number
  }, [initialTime, reset])

  useEffect(() => {
    if (value <= 0 && intervalIdRef.current) {
      reset()
      onFinish()
    }
  }, [onFinish, reset, value, initialTime])

  useEffect(() => reset, [reset])

  return [value, start, reset]
}
